/**
 *
 * @param {function} fn
 * @param {object} context
 * @param {number} during
 */
function throttle(fn, context, during = 100) {
  let prev = 0;
  let timeoutId = null;

  return function (..._args) {
    const now = Date.now();
    const reset = now - prev;

    if (reset >= during) {
      prev = now;
      // 这里必须要清除一下否则会出现极端情况，两个都执行
      // setTimeout在50ms触发，并且在50ms处同步也触发
      // 会有两种情况，一种是异步先，这不会正常
      // 同步先的话没有clearTimout，那么同步执行完成之后，异步会接着执行
      // 这就导致短时间内执行两次
      clearTimeout(timeoutId);
      fn.apply(context || this, _args);
    } else {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        prev = Date.now();
        fn.apply(context || this, _args);
      }, during - reset);
    }
  };
}

export default throttle;
